var CompareTableSectionComponentController = (function () {
    function CompareTableSectionComponentController() {
    }
    CompareTableSectionComponentController.prototype.$onInit = function () {
        if (typeof this.expanded === 'undefined') {
            this.expanded = false;
        }
    };
    CompareTableSectionComponentController.prototype.toggle = function () {
        this.expanded = !this.expanded;
    };
    return CompareTableSectionComponentController;
}());
export var CompareTableSectionComponent = {
    bindings: {
        expanded: '<',
        header: '<',
        headerCssClass: '@',
        tooltip: '<',
    },
    controller: CompareTableSectionComponentController,
    template: "\n    <div class=\"compare-table-section__header {{ $ctrl.headerCssClass }}\" ng-click=\"$ctrl.toggle()\" ng-class=\"{ expanded: $ctrl.expanded }\">\n      <span class=\"compare-table-section__title\" ng-bind=\"$ctrl.header\"></span>\n      <span class=\"compare-table__tooltip ml-2\" ng-show=\"$ctrl.tooltip\" uib-tooltip-html=\"$ctrl.tooltip\">i</span>\n      <span class=\"compare-table-section__arrow material-icons-outlined\">chevron_right</span>\n    </div>\n    <div class=\"compare-table-section__content\" ng-show=\"$ctrl.expanded\" ng-cloak ng-transclude></div>\n  ",
    transclude: true,
};
